"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ErrorAccount = void 0;

var _utilCrypto = require("@polkadot/util-crypto");

var _util = require("@polkadot/util");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ErrorAccount = /*#__PURE__*/function (_Error) {
  _inherits(ErrorAccount, _Error);

  var _super = _createSuper(ErrorAccount);

  function ErrorAccount() {
    var _this;

    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, ErrorAccount);

    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));
    _this.status = status;
    return _this;
  }

  return _createClass(ErrorAccount);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ErrorAccount = ErrorAccount;
var _isReady = false;
var _isError = undefined;

var AccountManager = /*#__PURE__*/function () {
  function AccountManager(keyring) {
    var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, AccountManager);

    this.keyring = keyring;
    this.setApi(api);
    this.account = null;
    this.subscription = false;
    this.rws = null;
    this.listeners = [];
    _isReady = true;
  }

  _createClass(AccountManager, [{
    key: "mixin",
    value: function () {
      var _mixin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.account.signMsg = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt("return", Promise.resolve((0, _util.u8aToHex)(this.account.sign(data))));

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function mixin() {
        return _mixin.apply(this, arguments);
      }

      return mixin;
    }()
  }, {
    key: "setApi",
    value: function setApi(api) {
      if (api) {
        this.keyring.setSS58Format(api.registry.chainSS58);
      }

      this.api = api;
    }
  }, {
    key: "setRws",
    value: function setRws(rws) {
      this.rws = rws;
    }
  }, {
    key: "onReady",
    value: function onReady(cb) {
      var _this2 = this;

      if (_isReady || _isError) {
        cb(_isError);
      } else {
        setTimeout(function () {
          _this2.onReady(cb);
        }, 1000);
      }
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      var _this3 = this;

      var pairs = this.keyring.getPairs();
      return pairs.map(function (pair) {
        return _objectSpread(_objectSpread({}, pair), {}, {
          address: (0, _utilCrypto.encodeAddress)(pair.address, _this3.api.registry.chainSS58)
        });
      });
    }
  }, {
    key: "selectAccountByAddress",
    value: function () {
      var _selectAccountByAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(address) {
        var account, _iterator, _step, cb;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                account = this.keyring.getPair(address);
                this.account = _objectSpread(_objectSpread({}, account), {}, {
                  address: (0, _utilCrypto.encodeAddress)(account.address, this.api.registry.chainSS58)
                });
                _context3.next = 4;
                return this.mixin();

              case 4:
                _iterator = _createForOfIteratorHelper(this.listeners);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    cb = _step.value;
                    cb(this.account);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _context3.abrupt("return", this.account);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function selectAccountByAddress(_x2) {
        return _selectAccountByAddress.apply(this, arguments);
      }

      return selectAccountByAddress;
    }()
  }, {
    key: "onChange",
    value: function onChange(cb) {
      var _this4 = this;

      this.listeners.push(cb);
      return function () {
        var i = _this4.listeners.indexOf(cb);

        _this4.listeners.splice(i, 1);
      };
    }
  }, {
    key: "useSubscription",
    value: function useSubscription() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.subscription = address;
    }
  }, {
    key: "signAndSend",
    value: function () {
      var _signAndSend = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(tx) {
        var _this5 = this;

        var options,
            devices,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

                if (!(this.account === null)) {
                  _context5.next = 3;
                  break;
                }

                throw new ErrorAccount(3, "No account selected");

              case 3:
                if (!this.subscription) {
                  _context5.next = 12;
                  break;
                }

                if (this.rws.isSubscription(this.subscription)) {
                  _context5.next = 6;
                  break;
                }

                throw new ErrorAccount(3, "Not subscription for ".concat(this.subscription));

              case 6:
                _context5.next = 8;
                return this.rws.getDevices(this.subscription);

              case 8:
                devices = _context5.sent;

                if (devices.includes(this.account.address)) {
                  _context5.next = 11;
                  break;
                }

                throw new ErrorAccount(3, "Not device ".concat(this.account.address, " for ").concat(this.subscription));

              case 11:
                tx = this.rws.call(this.subscription, tx);

              case 12:
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  tx.signAndSend(_this5.account.meta.isInjected ? _this5.account.address : _this5.account, options, function (result) {
                    if (result.status.isInBlock) {
                      result.events.forEach( /*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(events) {
                          var _events$event, data, method, section, phase, message, mod, _mod$registry$findMet, docs, name, _section, block;

                          return regeneratorRuntime.wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  _events$event = events.event, data = _events$event.data, method = _events$event.method, section = _events$event.section, phase = events.phase;

                                  if (!(section === "system" && method === "ExtrinsicFailed")) {
                                    _context4.next = 7;
                                    break;
                                  }

                                  message = "Error";

                                  if (data[0].isModule) {
                                    mod = data[0].asModule; // const mod = result.dispatchError.asModule;

                                    // const mod = result.dispatchError.asModule;
                                    _mod$registry$findMet = mod.registry.findMetaError(mod), docs = _mod$registry$findMet.docs, name = _mod$registry$findMet.name, _section = _mod$registry$findMet.section;
                                    console.log(name, _section, docs);
                                    message = docs.join(", ");
                                  }

                                  return _context4.abrupt("return", reject(new ErrorAccount(4, message)));

                                case 7:
                                  if (!(section === "system" && method === "ExtrinsicSuccess")) {
                                    _context4.next = 12;
                                    break;
                                  }

                                  _context4.next = 10;
                                  return _this5.api.rpc.chain.getBlock(result.status.asInBlock.toString());

                                case 10:
                                  block = _context4.sent;
                                  resolve({
                                    block: result.status.asInBlock.toString(),
                                    blockNumber: block.block.header.number.toNumber(),
                                    // const index = phase.value.toNumber();
                                    txIndex: phase.asApplyExtrinsic.toHuman(),
                                    tx: tx.hash.toString()
                                  });

                                case 12:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));

                        return function (_x4) {
                          return _ref2.apply(this, arguments);
                        };
                      }());
                    }
                  })["catch"](reject);
                }));

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function signAndSend(_x3) {
        return _signAndSend.apply(this, arguments);
      }

      return signAndSend;
    }()
  }], [{
    key: "isReady",
    value: function isReady() {
      return _isReady;
    }
  }, {
    key: "setReady",
    value: function setReady(status) {
      _isReady = status;
    }
  }, {
    key: "isError",
    value: function isError() {
      return _isError;
    }
  }]);

  return AccountManager;
}();

exports["default"] = AccountManager;